<ng-container *ngIf="graphData?.length && !loader['graphLoader']">
    <ng-container *ngFor="let item of graphData; let i = index; trackBy: feUtil.trackByFn; let first = first">
        <nz-row [nzAlign]="'middle'" [nzGutter]="[16, 32]">
            <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="viewOptions.view?.includes('readings') ? 18 : 24" *ngIf="viewOptions.view?.includes('graph')">
                <nz-card aria-label="Line Chart Card">
                    <nz-page-header class="px-0 py-2">
                        <nz-page-header-title class="text-base" *ngIf="viewOptions.showTitle ?? true">{{ item?.matrixType && item?.matrixType == 'pressure' ? 'Differential Pressure' : item?.matrixType | titlecase }}</nz-page-header-title>
                        <nz-page-header-content>
                            <div class="flex justify-between items-center flex-wrap gap-2">
                                @if(isActive && viewOptions.radio?.show) {
                                <nz-radio-group [(ngModel)]="filterType" (ngModelChange)="onRadioChange()"
                                    nzButtonStyle="outline">
                                    <label nz-radio-button nzValue="today" class="font-semibold">Today</label>
                                    <label nz-radio-button nzValue="yesterday" class="font-semibold">Yesterday</label>
                                    <label nz-radio-button nzValue="week" class="font-semibold">Last 7 Days</label>
                                    <label nz-radio-button nzValue="month" class="font-semibold">Last 30 Days</label>
                                </nz-radio-group>
                                }
                                @if(viewOptions.dateRange?.show) {
                                <nz-range-picker [nzDisabled]="viewOptions.dateRange?.disable"
                                    [nzDisabledDate]="disableFutureDates" nzPlacement="bottomRight" [(ngModel)]="metaData.date"
                                    (ngModelChange)="onDateRangeChange($event)"></nz-range-picker>
                                }
                            </div>
                        </nz-page-header-content>
                        <nz-page-header-extra>
                            <ng-container *ngIf="feUtil.isProduction && feUtil.user_data.customer.customer_id === 19407">
                                <button nz-button nzSize="small" nzType="default" (click)="onDownloadClick()"
                                    [nzLoading]="loader['downloadLoader']">
                                    <i nz-icon nzType="download" nzTheme="outline"></i>
                                    Download Excel
                                </button>
                            </ng-container>
                        </nz-page-header-extra>
                    </nz-page-header>
                    <!-- Chart Component -->
                    <apx-chart [series]="item?.chartOptions?.series" [chart]="chart" [dataLabels]="dataLabels"
                        [markers]="markers" [fill]="fill" [yaxis]="yaxis" [xaxis]="xaxis"
                        [autoUpdateSeries]="true" [annotations]="item.chartOptions?.annotations"
                        [legend]="legend"></apx-chart>
                </nz-card>
            </nz-col>
            <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="6" *ngIf="viewOptions.view?.includes('readings')">
                <nz-card nzTitle="Last Reading" [nzExtra]="sensorDropDown" aria-label="Last Reading Card">
                    <ng-container *ngIf="!loader['logLoader']">
                        <cdk-virtual-scroll-viewport itemSize="30" class="desktop:h-[400px] h-[500px] overflow-auto"
                            aria-label="Last Reading List">
                            <ul nz-list nzSize="small" aria-label="Last Reading List">
                                <li style="padding: 8px 0;" nz-list-item
                                    *cdkVirtualFor="let reading of item['lastReadingData'][item['selectedSensorType']]; trackBy: feUtil.trackByFn">
                                    <div class="flex justify-between w-full text-xs mr-2">
                                        <div class="flex">
                                            <span class="flex items-center gap-2 mr-2">
                                                <i nz-icon nzType="calendar" nzTheme="outline"></i>
                                                {{ reading?.datetime | gDate: 'MMM d, y'}}
                                            </span>
                                            <span class="flex items-center gap-2">
                                                <i nz-icon nzType="clock-circle" nzTheme="outline"></i>
                                                {{ reading?.datetime | gDate: 'HH:mm:ss'}}
                                            </span>
                                        </div>
                                        <span class="flex items-center gap-2">
                                            {{ feUtil.getFormattedTemp(reading?.value, item.matrixType) }}
                                        </span>
                                    </div>
                                </li>
                            </ul>
                        </cdk-virtual-scroll-viewport>
                    </ng-container>
                    <!-- Skeleton Loader -->
                    <nz-skeleton *ngIf="loader['logLoader']" class="p-2" [nzTitle]="false" [nzRound]="true"
                        [nzActive]="true" [nzParagraph]="{ rows: 12 }"></nz-skeleton>
                </nz-card>
            </nz-col>
            <!-- Sensor Dropdown Template -->
            <ng-template #sensorDropDown>
                <nz-select nzBorderless [(ngModel)]="item['selectedSensorType']" nzMode="default" aria-label="Sensor Dropdown">
                    <nz-option *ngFor="let option of item['sensorTypeOptions']" [nzValue]="option" [nzLabel]="option | titlecase"></nz-option>
                </nz-select>
            </ng-template>
        </nz-row>
    </ng-container>
</ng-container>

<!-- No Data Found Section -->
<ng-container *ngIf="!graphData?.length && !loader['graphLoader']">
    <ng-container *ngFor="let item of capabilities">
        <nz-row [nzAlign]="'middle'" [nzGutter]="[16, 32]">
            <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="viewOptions.view?.includes('readings') ? 18 : 24" *ngIf="viewOptions.view?.includes('graph')">
                <nz-card aria-label="Line Chart Card"
                    [nzBodyStyle]="{ 'min-height': '400px', 'max-height': '400px', 'overflow-y': 'hidden', 'overflow-x': 'hidden' }">
                    <nz-page-header class="px-0 py-2">
                        <nz-page-header-title class="text-base">{{ item | titlecase }}</nz-page-header-title>
                        <nz-page-header-content>
                            <div class="flex justify-between items-center flex-wrap gap-2">
                                @if(isActive && viewOptions.radio?.show) {
                                <nz-radio-group [(ngModel)]="filterType" (ngModelChange)="onRadioChange()" nzButtonStyle="outline">
                                    <label nz-radio-button nzValue="today" class="font-semibold">Today</label>
                                    <label nz-radio-button nzValue="yesterday" class="font-semibold">Yesterday</label>
                                    <label nz-radio-button nzValue="week" class="font-semibold">Last 7 Days</label>
                                    <label nz-radio-button nzValue="month" class="font-semibold">Last 30 Days</label>
                                </nz-radio-group>
                                }
                                @if(viewOptions.dateRange?.show) {
                                <nz-range-picker [nzDisabled]="viewOptions.dateRange?.disable"
                                    [nzDisabledDate]="disableFutureDates" nzPlacement="bottomRight" [(ngModel)]="metaData.date"
                                    (ngModelChange)="onDateRangeChange($event)"></nz-range-picker>
                                }
                            </div>
                        </nz-page-header-content>
                    </nz-page-header>
                    <div class="place-content-center">
                        <nz-empty [nzNotFoundImage]="isActive ? 'default' : noGraphDataDecommissioned"
                            [nzNotFoundContent]="isActive ? 'No graph data available for the selected time period' : ''">
                        </nz-empty>
                    </div>
                </nz-card>
            </nz-col>
            <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="6" *ngIf="viewOptions.view?.includes('readings')">
                <nz-card aria-label="Last Reading Card" [nzBodyStyle]="{ 'min-height': '400px', 'max-height': '400px', 'overflow-y': 'hidden', 'overflow-x': 'hidden'}">
                    <div class="place-content-center h-[300px]">
                        <nz-empty [nzNotFoundImage]="isActive ? 'default' : noLastReadingDataDecommissioned"
                            [nzNotFoundContent]="isActive ? 'No graph data available for the selected time period' : ''">
                        </nz-empty>
                    </div>
                </nz-card>
            </nz-col>
        </nz-row>
    </ng-container>
</ng-container>

<!-- Loading Section -->
<ng-container *ngIf="loader['graphLoader']">
    <ng-container *ngFor="let item of capabilities">
        <nz-row [nzAlign]="'middle'" [nzGutter]="[16, 32]">
            <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="viewOptions.view?.includes('readings') ? 18 : 24" *ngIf="viewOptions.view?.includes('graph')">
                <nz-card aria-label="Line Chart Card"
                    [nzBodyStyle]="{ 'min-height': '400px', 'max-height': '400px', 'overflow-y': 'hidden', 'overflow-x': 'hidden' }">
                    <nz-page-header class="px-0 py-2">
                        <nz-page-header-title class="text-base">{{ item && item == 'pressure' ? 'Differential Pressure' : item | titlecase }}</nz-page-header-title>
                        <nz-page-header-content>
                            <div class="flex justify-between items-center flex-wrap gap-2">
                                @if(isActive && viewOptions.radio?.show) {
                                <nz-radio-group [(ngModel)]="filterType" (ngModelChange)="onRadioChange()"
                                    nzButtonStyle="outline">
                                    <label nz-radio-button nzValue="today" class="font-semibold">Today</label>
                                    <label nz-radio-button nzValue="yesterday" class="font-semibold">Yesterday</label>
                                    <label nz-radio-button nzValue="week" class="font-semibold">Last 7 Days</label>
                                    <label nz-radio-button nzValue="month" class="font-semibold">Last 30 Days</label>
                                </nz-radio-group>
                                }
                                @if(viewOptions.dateRange?.show) {
                                <nz-range-picker [nzDisabled]="viewOptions.dateRange?.disable"
                                    [nzDisabledDate]="disableFutureDates" nzPlacement="bottomRight" [(ngModel)]="metaData.date"
                                    (ngModelChange)="onDateRangeChange($event)"></nz-range-picker>
                                }
                            </div>
                        </nz-page-header-content>
                    </nz-page-header>
                    <nz-spin [nzSpinning]="true" [nzTip]="'Loading '+ (item | lowercase) +' graph...'"
                        class="h-[200px]"></nz-spin>
                </nz-card>
            </nz-col>
            <nz-col [nzXs]="24" [nzSm]="24" [nzMd]="24" [nzLg]="viewOptions.view?.includes('readings') ? 6 : 24" *ngIf="viewOptions.view?.includes('readings')">
                <nz-card aria-label="Last Reading Card"
                    [nzBodyStyle]="{ 'min-height': '400px', 'max-height': '400px', 'overflow-y': 'hidden', 'overflow-x': 'hidden' }">
                    <nz-skeleton [nzActive]="true" [nzParagraph]="{ rows: 10 }"></nz-skeleton>
                </nz-card>
            </nz-col>
        </nz-row>
    </ng-container>
</ng-container>

<!-- No Graph Data Decommissioned Template -->
<ng-template #noGraphDataDecommissioned>
    <div class="flex flex-col items-center justify-center p-6">
        <i nz-icon nzType="warning" nzTheme="twotone" [nzTwotoneColor]="'#F59E42'" class="text-7xl mb-3"></i>
        <h3 class="text-lg font-semibold text-yellow-700 mb-1 text-center">
            Asset has been decommissioned
        </h3>
        <p class="text-sm text-gray-600 mb-1 text-center">
            This asset was decommissioned on
            <span class="font-medium text-gray-800">{{ decommissionDate | gDate: 'MMM d, y, h:mm a' }}</span>
        </p>
        <div class="flex flex-col items-center mt-2">
            <span class="text-sm text-gray-600 text-center">
                <strong>To view historical data:</strong> Select a date <span class="text-yellow-700 font-medium">prior
                    to the decommission date</span> to access previous records.
            </span>
        </div>
    </div>
</ng-template>

<!-- No Last Reading Data Decommissioned Template -->
<ng-template #noLastReadingDataDecommissioned>
    <div class="flex flex-col items-center justify-center p-6">
        <i nz-icon nzType="warning" nzTheme="twotone" [nzTwotoneColor]="'#F59E42'" class="text-7xl mb-3"></i>
        <h3 class="text-lg font-semibold text-yellow-700 mb-1 text-center">
            Asset has been decommissioned
        </h3>
        <div class="flex flex-col items-center mt-2">
            <span class="text-sm text-gray-600 text-center">
                <strong>To view historical data:</strong> Select a date <span class="text-yellow-700 font-medium">prior
                    to the decommission date</span> to access previous records.
            </span>
        </div>
    </div>
</ng-template>